import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';

function List() {

    const pathFrontEnd = '/gci/sides/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/sides/delete`,
        endpoint: `${endpointBackend}gci/sides/getall`
    }

    let list = {
        labelTitle: 'Lista de Lados - Unidades',
        labelTitleButtonAdd: 'Incluir novo lado - unidade',
        fieldsShowOnDelete: ['name'],
        columns: [
            {
                name: 'name',
                label: 'Nome',
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
